import type React from "react";

/**
 * Unizo ブランドロゴ (象シンボル + ワードマーク)。
 *
 * PRODUCT_DEV-570: 従来テキストのワードマーク
 * (`text-primary italic font-black leading-none text-[28px]` + "Unizo") を
 * 公式ロゴ画像に差し替え。左上ロゴとして各画面で共通利用する。
 * 余白などレイアウト差分は `className` で上書きする。
 */
export const UnizoLogo: React.FC<{ className?: string }> = ({ className }) => (
  <img
    src={`${import.meta.env.BASE_URL}assets/logo/unizo-logo.png`}
    alt="Unizo"
    className={`h-7 w-auto${className ? ` ${className}` : ""}`}
  />
);

export default UnizoLogo;
